export default{badge:"w_D",blue:"w_E",gray:"w_F",green:"w_G",purple:"w_H",red:"w_I",spark:"w_J",white:"w_K",hasTextLabel:"w_L"};
